import { useEffect, useRef } from 'react';

export const useNavigateSteps = ({ stepsContainerRef, currentStep }) => {
  const prevStepRef = useRef(currentStep);

  useEffect(() => {
    if (prevStepRef.current !== currentStep) {
      if (currentStep > prevStepRef.current) {
        moveSteps();
      } else {
        moveSteps(false);
      }

      prevStepRef.current = currentStep;
    }
  }, [currentStep]);

  const moveSteps = async (forward = true) => {
    const targets = Array.from(stepsContainerRef.current.children);

    for (let i = 0; i < targets.length; i++) {
      if (i === prevStepRef.current - 1) {
        if (forward) {
          targets[i].style.transform = 'translateX(-150%)';
          targets[currentStep - 1].style.transform = 'translateX(0)';
        } else {
          targets[i].style.transform = 'translateX(150%)';
          targets[currentStep - 1].style.transform = 'translateX(0)';
        }
      }
    }
  };
};
